export default class AdminPharmacies {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPharmaciesRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPharmaciesRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPharmaciesRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPharmaciesRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPharmaciesRoute}/${id}`, payload, {})
  }

  approve(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPharmaciesRoute}/${id}/approve`, {})
  }

  decline(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPharmaciesRoute}/${id}/decline`, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminPharmaciesRoute}/${id}`, {})
  }
}
